(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var cardSelector = '[data-collection-image-rotation]';
    var dataSelector = '[data-collection-image-rotation-data]';
    var intervalMs = 20000;
    var fadeMs = 350;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function getCards(root) {
      var cards = [];
      if (root.matches && root.matches(cardSelector)) {
        cards.push(root);
      }
      return cards.concat(Array.prototype.slice.call(root.querySelectorAll(cardSelector)));
    }

    function applyImage(card, element, image) {
      element.src = image.src;
      if (image.srcset) {
        element.srcset = image.srcset;
      } else {
        element.removeAttribute('srcset');
      }
      element.alt = image.alt || '';
      if (image.width) {
        element.width = image.width;
      }
      if (image.height) {
        element.height = image.height;
      }
      requestAnimationFrame(function () {
        card.classList.remove('collection-image-is-changing');
      });
    }

    function changeImage(card, element, image) {
      var preload = new Image();
      preload.sizes = element.sizes;
      if (image.srcset) {
        preload.srcset = image.srcset;
      }
      preload.src = image.src;

      var swap = function () {
        card.classList.add('collection-image-is-changing');
        window.setTimeout(function () {
          applyImage(card, element, image);
        }, fadeMs);
      };

      if (preload.complete) {
        swap();
      } else {
        preload.addEventListener('load', swap, { once: true });
      }
    }

    function schedule(card, element, images, position) {
      var phaseMs = position * 1250;
      var elapsed = (Date.now() + phaseMs) % intervalMs;
      var delay = intervalMs - elapsed;

      card.collectionImageRotationTimer = window.setTimeout(function tick() {
        if (!document.hidden) {
          var nextIndex = Math.floor((Date.now() + phaseMs) / intervalMs) % images.length;
          changeImage(card, element, images[nextIndex]);
        }
        card.collectionImageRotationTimer = window.setTimeout(tick, intervalMs);
      }, delay);
    }

    function initialise(root) {
      if (reducedMotion.matches) {
        return;
      }

      getCards(root).forEach(function (card, index) {
        if (card.dataset.collectionImageRotationReady === 'true') {
          return;
        }

        var dataElement = card.querySelector(dataSelector);
        var imageElement = card.querySelector('.card__media img');
        if (!dataElement || !imageElement) {
          return;
        }

        var images;
        try {
          images = JSON.parse(dataElement.textContent);
        } catch (error) {
          return;
        }

        if (!Array.isArray(images) || images.length < 2) {
          return;
        }

        card.dataset.collectionImageRotationReady = 'true';
        var position = Number(card.dataset.collectionImageRotationPosition || index);
        var phaseMs = position * 1250;
        var currentIndex = Math.floor((Date.now() + phaseMs) / intervalMs) % images.length;
        applyImage(card, imageElement, images[currentIndex]);
        schedule(card, imageElement, images, position);
      });
    }

    function cleanup(root) {
      getCards(root).forEach(function (card) {
        if (card.collectionImageRotationTimer) {
          window.clearTimeout(card.collectionImageRotationTimer);
        }
      });
    }

    initialise(document);

    document.addEventListener('shopify:section:load', function (event) {
      initialise(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      cleanup(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-image-rotation]';

    const showImage = (images, activeIndex) => {
      images.forEach((image, index) => {
        const isActive = index === activeIndex;
        image.classList.toggle('is-active', isActive);
        image.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    };

    const stopRotation = (rotator) => {
      window.clearTimeout(rotator.imageRotationTimeout);
      window.clearInterval(rotator.imageRotationInterval);
    };

    const startRotation = (rotator) => {
      if (rotator.dataset.rotationReady === 'true') return;
      rotator.dataset.rotationReady = 'true';

      const images = Array.from(rotator.querySelectorAll('.image-with-text__rotation-image'));
      if (images.length < 2) return;

      showImage(images, 0);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const interval = Number(rotator.dataset.rotationInterval) || 20000;
      const update = () => {
        const activeIndex = Math.floor(Date.now() / interval) % images.length;
        showImage(images, activeIndex);
      };

      update();

      const delay = interval - (Date.now() % interval) + 50;
      rotator.imageRotationTimeout = window.setTimeout(() => {
        update();
        rotator.imageRotationInterval = window.setInterval(update, interval);
      }, delay);
    };

    const initialize = (root) => {
      root.querySelectorAll(selector).forEach(startRotation);
    };

    const cleanup = (root) => {
      root.querySelectorAll(selector).forEach(stopRotation);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else {
      initialize(document);
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => cleanup(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
